<template>
  <section
    :class="$vuetify.theme.dark ? 'grey darken-4' : 'bg-light-grey'"
    class="py-4 bg-light-grey mb-6"
  >
    <v-container>
      <v-row>
        <v-col cols="12" md="3">
          <div>
            <div class="px-2 text-center">
              <v-icon class="mb-4" large>fal fa-hands-usd</v-icon>
              <h4 class="text-subtitle-1 font-weight-bold text-uppercase mb-4">
                Free shipping
              </h4>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="3">
          <div>
            <div class="px-2 text-center">
              <v-icon class="mb-4" large>fal fa-truck</v-icon>
              <h4 class="text-subtitle-1 font-weight-bold text-uppercase mb-4">
                Fortnight delivery
              </h4>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="3">
          <div>
            <div class="px-2 text-center">
              <v-icon class="mb-4" large>fal fa-scarecrow</v-icon>
              <h4 class="text-subtitle-1 font-weight-bold text-uppercase mb-4">
                Created with care
              </h4>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="3">
          <div>
            <div class="px-2 text-center">
              <v-icon class="mb-4" large>fal fa-house-return</v-icon>
              <h4 class="text-subtitle-1 font-weight-bold text-uppercase mb-4">
                Free return
              </h4>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'ShopPerks'
}
</script>
